import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { BoosterWagerBonus, LevelUpBonus } from 'config/types/bonus/userBonus'
import useModal from 'hooks/useModal'
import React from 'react'
import BonusDetailsModal from 'views/BonusCenter/components/BonusDetailsModal'
import { useDisplayBonusName } from 'views/BonusCenter/hooks'
import BoostInUseCountDown from './BoostInUseCountDown'

interface BoosterInUsedTooltipSectionProps {
  bonus: BoosterWagerBonus | LevelUpBonus
  image: string
}

const BoosterInUsedTooltipSection: React.FC<BoosterInUsedTooltipSectionProps> = ({ bonus, image }) => {
  const [name] = useDisplayBonusName(bonus.info?.name)
  const [onPresentBonusDetailModal] = useModal(BonusDetailsModal)

  return (
    <Flex
      height="36px"
      width="100%"
      onClick={() => (bonus ? onPresentBonusDetailModal({ bonus }) : null)}
      style={{ cursor: 'pointer' }}
    >
      <Flex width="100%" justifyContent="space-between" alignItems="center">
        <Flex width="100%" justifyContent="center" alignItems="center">
          <Box width={36} height={36} mt="5px">
            <Image src={image} width={36} height={36} />
          </Box>

          <Flex justifyContent="space-between" alignItems="center" width="100%" height="36px" marginLeft="4px">
            <Text fontSize="14px" fontWeight={500} letterSpacing={-0.28} ellipsis={1} maxWidth="100%">
              {name}
            </Text>
          </Flex>
        </Flex>

        <BoostInUseCountDown expiredTime={bonus?.condition.expiryDate} />
      </Flex>
    </Flex>
  )
}

export default BoosterInUsedTooltipSection
